/**
 * @author Ariel
 * @date 2020-08-13
 * @description 报名管理--新增编辑第3步：报名受众设置
 */
import React from 'react';
import { connect } from 'dva';
import { modelUtils } from '@/utils';
import { utils_tool, framework_tool,component_tool  } from '@/tool';
import ApplyAuthSelect from "./applyAuthSelect";

let { Session } = utils_tool;
let { WizContainer } = framework_tool
let {
  WizModal,
} = component_tool;
class ApplyAuth extends WizContainer {
  componentName = 'applyAuth';

  constructor(props) {
    super(props);
    this.state = {
      id: props.applyId,
      initInfo: props.initialValue,
      planIds: props.initialValue && props.initialValue['planIds'],
      initialValue: {},
      resetTime: new Date().getTime()
    }
  }

  _componentDidMount() {
    this.doActions([
      {
        path: 'apply/authInfo',
        payload: {
          key: 'authInfoKey',
          apiParams: { id: this.state.id }
        }
      },
      {
        path: 'apply/getApplyInfo',
        payload: {
          key: 'getApplyInfo',
          apiParams: { id: this.state.id }
        }
      }
    ]);
    const arr = [];
    this.setState({
      data: arr
    });
  }

  propsAndStateOnChange = {
    applyInfo: this._applyInfo.bind(this),
    authInfo: this._authInfo.bind(this),
    saveAuthKey: this._saveAuthKey.bind(this),
  };

  _applyInfo(nextProps, nextState) {
    let { applyInfo } = nextProps
    if (applyInfo && applyInfo['success']) {
      nextState.planIds = applyInfo['data'].planIds
    } else {
      wizNotice.error(applyInfo && applyInfo['msg'] || '获取报名信息失败，请稍后尝试')
    }
    return false
  }

  _authInfo(nextProps, nextState) {
    let { authInfo } = nextProps
    if (authInfo && authInfo['success']) {
      nextState.initialValue = authInfo['data']
    } else {
      wizNotice.error(authInfo && authInfo['msg'] || '操作失败,请稍后尝试')
    }
    return false
  }

  _saveAuthKey(nextProps, nextState) {
    let { saveAuthKey } = nextProps
    if (saveAuthKey && saveAuthKey['success']) {
      wizNotice.success(saveAuthKey['msg'])
      let saveId = saveAuthKey["data"]
      if(saveId){
        if(saveId>0){
        WizModal.confirm({
          title: '注意', content:"消息通知内容有变更，是否重新发送消息通知",cancelText:"否",okText:"是",
          onOk: () => {
            this.doActions([
              {
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: saveId,
                    bizType: 15,
                    resend:true
                  },
                },
              },
            ]);
            this.jumpPage('replace', '/workflow/apply');
          },
          onCancel: () => {
            this.doActions([
              {
                path:  "notice/sendNotice",
                payload: {
                  key: "sendNoticeKey",
                  apiParams: {
                    bizId: saveId,
                    bizType: 15,
                    resend:false
                  },
                },
              },
            ]);
            this.jumpPage('replace', '/workflow/apply');
          }
        });
      }else{
        this.doActions([
          {
            path:  "notice/sendNotice",
            payload: {
              key: "sendNoticeKey",
              apiParams: {
                bizId: 0-saveId,
                bizType: 15,
                resend:false
              },
            },
          },
        ]);
        this.jumpPage('replace', '/workflow/apply');
      }
      }else{
        this.jumpPage('replace', '/workflow/apply');
      }
      this.jumpPage('replace', '/workflow/apply');
      return true
    } else {
      wizNotice.error(saveAuthKey && saveAuthKey['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _render() {
    const { initialValue, planIds } = this.state
    const { applyLoading, prevFunc } = this.props
    const selectProps = {
      loading: applyLoading,
      prevFunc: prevFunc,
      this: this,
      id: this.state.id,
      initialValue: initialValue,
      submit: (value, flag) => {
        if (flag) {
          if (planIds && planIds.length) {
            this.doAction({
              path: 'apply/enable',
              payload: {
                key: "applyEnable",
                apiParams: { id: this.state.id, status: 1 }
              }
            })
          } else {
            wizNotice.error('该报名还未设计计划安排，不能发布')
            return false;
          }
        }
        let saveRequest = {}
        if (value['dataAuth']) {
          let dataAuth = value['dataAuth']
          if(value['dataAuth'].groupId && value['dataAuth'].groupId.length) {
            saveRequest['groupId'] = dataAuth['groupId'].map(p => (p.id)).toString();
          }else{
            saveRequest['orgIds'] = dataAuth['orgIds'] && dataAuth['orgIds'].map(p => (p.id))
            saveRequest['positionIds'] = dataAuth['positionIds'] && dataAuth['positionIds'].map(p => (p.id))
            saveRequest['positionCategoryIds'] = dataAuth['positionCategoryIds'] && dataAuth['positionCategoryIds'].map(p => (p.id))
            saveRequest['personIds'] = dataAuth['personIds'] && dataAuth['personIds'].map(p => (p['id']))
          }
        }
        saveRequest['id'] = this.state.id
        this.doAction({
          path: 'apply/saveAuth',
          payload: {
            key: "applySaveAuthKey",
            apiParams: { ...saveRequest }
          }
        })
      },
    };
    return <ApplyAuthSelect {...selectProps} />
  }

}

const mapStateToProps = (state, ownProps) => {

  const { apply } = state;
  const applyInfo = modelUtils.getModelEntity(apply, "getApplyInfo");
  const authInfo = modelUtils.getModelEntity(apply, "authInfoKey");
  const saveAuthKey = modelUtils.getModelEntity(apply, "applySaveAuthKey");
  const load = modelUtils.getLoadingState(state, 'apply');

  return {
    applyInfo,
    authInfo,
    saveAuthKey,
    ...load
  }
};

export default connect(mapStateToProps)(ApplyAuth)
